import React from 'react';

export const RemoteDataContext = React.createContext({
  loading: false,
  offline: false,
  remoteData: {},
  selectors: {
    useGetSync: () => {},
  },
  operations: {
    useRemoteData: () => {},
    updateEntity: () => {},
    invalidateRemoteData: () => {},
  },
  global: {
    emptyData: () => {},
  },
});
